import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PhysicalAiHero from "../components/physical-ai/PhysicalAiHero";
import Factory360Section from "../components/physical-ai/Factory360Section";
import Factory360ProcessProducts from "../components/physical-ai/Factory360ProcessProducts";
import IntelligenceLayerSection from "../components/physical-ai/IntelligenceLayerSection";
import ExploreSolutionsSection from "../components/physical-ai/ExploreSolutionsSection";
import PhysicalAiTestimonialsSection from "../components/physical-ai/PhysicalAiTestimonialsSection";
import ConnectedEcosystemSection from "../components/physical-ai/ConnectedEcosystemSection";
import PhysicalAiCtaSection from "../components/physical-ai/PhysicalAiCtaSection";

const CognitiveAI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen w-full bg-white">
      <Navbar />
      <main>
        {/* Physical AI Hero Section */}
        <PhysicalAiHero />

        {/* Factory 360 Section */}
        <Factory360Section />

        {/* Factory 360 Process & Products */}
        <Factory360ProcessProducts />

        {/* Intelligence Layer Section */}
        <IntelligenceLayerSection />

        {/* Explore Physical AI Solutions Section */}
        <ExploreSolutionsSection />

        {/* Real-World Impact / Testimonials Section */}
        <PhysicalAiTestimonialsSection />

        {/* Connected Ecosystem Section */}
        <ConnectedEcosystemSection />

        {/* Physical AI CTA Section */}
        <PhysicalAiCtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default CognitiveAI;
